module.exports = __webpack_public_path__ + "media/images/icon-carrot-5e1b0dd2.png";